import CrmRepository from "./CrmRepository";
import LabRepository from "../lab/LabRepository";

const resource = "/customers";

export default {
  getAll(params) {
    return CrmRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return CrmRepository.get(`${resource}/${id}`, { params });
  },
  create(payload) {
    return CrmRepository.post(resource, payload);
  },
  update(id, payload) {
    return CrmRepository.put(`${resource}/${id}`, payload);
  },
  suspend(id) {
    return CrmRepository.delete(`${resource}/${id}`);
  },
  locations(id) {
    return CrmRepository.get(`${resource}/${id}/locations`);
  },
  contacts(id) {
    return CrmRepository.get(`${resource}/${id}/contacts`);
  },
  primaryLocation(id) {
    return CrmRepository.get(`${resource}/${id}/locations/primary`);
  },
  primaryContact(id) {
    return CrmRepository.get(`${resource}/${id}/contacts/primary`);
  },
  projects(id) {
    return LabRepository.get(`customer/${id}/projects`);
  },
  getFromUser(id, params) {
    return CrmRepository.get(`${resource}/users/${id}`, { params });
  },
};
